"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withHr = exports.insertHr = exports.insertParagraphNearActiveHr = exports.getActiveHrEntry = exports.isHrElement = void 0;
const slate_1 = require("slate");
const voidInsert_1 = require("./voidInsert");
const isHrElement = (node) => slate_1.Element.isElement(node) && node.type === 'hr';
exports.isHrElement = isHrElement;
const createHrElement = (overrides = {}) => {
    const children = [{ text: '' }];
    return {
        type: 'hr',
        children,
        ...overrides,
    };
};
const createParagraphElement = () => ({
    type: 'p',
    children: [{ text: '' }],
});
const getActiveHrEntry = (editor) => {
    const { selection } = editor;
    if (!selection)
        return null;
    const match = slate_1.Editor.above(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => (0, exports.isHrElement)(node),
    });
    return match ?? null;
};
exports.getActiveHrEntry = getActiveHrEntry;
const insertParagraphNearActiveHr = (editor, position = 'below') => {
    const entry = (0, exports.getActiveHrEntry)(editor);
    if (!entry)
        return null;
    const [, path] = entry;
    const targetPath = position === 'above' ? path : slate_1.Path.next(path);
    slate_1.Transforms.insertNodes(editor, createParagraphElement(), { at: targetPath });
    slate_1.Transforms.select(editor, slate_1.Editor.start(editor, targetPath));
    return targetPath;
};
exports.insertParagraphNearActiveHr = insertParagraphNearActiveHr;
const insertHr = (editor, overrides = {}) => (0, voidInsert_1.insertVoidBlock)(editor, createHrElement(overrides));
exports.insertHr = insertHr;
const withHr = (editor) => {
    const { isVoid, insertBreak, insertSoftBreak, insertText } = editor;
    editor.isVoid = (element) => (element.type === 'hr' ? true : isVoid(element));
    editor.insertBreak = () => {
        if ((0, exports.insertParagraphNearActiveHr)(editor, 'below'))
            return;
        insertBreak();
    };
    editor.insertSoftBreak = () => {
        if ((0, exports.insertParagraphNearActiveHr)(editor, 'above'))
            return;
        insertSoftBreak();
    };
    editor.insertText = (text) => {
        if (text && (0, exports.insertParagraphNearActiveHr)(editor, 'below')) {
            insertText(text);
            return;
        }
        insertText(text);
    };
    return editor;
};
exports.withHr = withHr;
